import faLang from './entries/fa-IR';
import enLang from './entries/en-US';
import esLang from './entries/es-ES';
import enRtlLang from './entries/en-US-rtl';

const AppLocale = {
  fa: faLang,
  en: enLang,
  es: esLang,
  enrtl: enRtlLang,
};

export default AppLocale;
